import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    getSign,
    parseParam
} from '@/util/util';
import axios from '../../router/axios';

export const findTotalMoney = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/finance/record?` + params,
        method: 'GET'
    })
}
export const findFinancialList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/finance/financeList?` + params,
        method: 'GET'
    })
}
export const findFinancialListDownloadExcel = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/finance/downloadExcel?` + params,
        method: 'GET'
    })
}
export const findLineData = (data) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v1/finance/list`,
        method: 'POST',
        data: data
    })
}
export const getPledgeType = () => {
    return request({
        url: `${baseUrl}/joins-wallet/v1/app_recharge/getPledgeType`,
        method: 'GET'
    })
}
export const addPledge = (data) => {
    return request({
        url: `${baseUrl}/joins-wallet/v1/pledge`,
        method: 'POST',
        data: data
    })
}
export const wxNativePayQuery = (outTradeNo) => {
    return request({
        url: `${baseUrl}/joins-pay/wx_native_pay_query/${outTradeNo}`,
        method: 'GET',
        timeout: 1000 * 120
    })
}